import { Box, Button, CardMedia, TextField, Typography } from "@mui/material";
import fondo2 from "../../Web Mundo/n7.png";
//import fondo from "../../Web Mundo/fondoweb.png";
import fondo from '../../Web Mundo/Fondo_new_islas_lhtanv.png'

import { HivePay } from "../../hivepay/hivepay";
import { useSelector } from "react-redux";
import { useState } from "react";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const URL = "https://bigdogbone.up.railway.app";
export const Market = () => {
  const { informacion } = useSelector((state) => state.userSlice);
  const [open, setOpen] = useState(false);
  const [input, setinput] = useState(null);
  const [pack, setPack] = useState("");
  const handleOpen = (nombre) => {
    setPack(nombre);
    setOpen(true);
  };
  const handlebuy = () => {
    if (input > 0 && pack !== "") {
      const MONEDA = pack === "inicial" 
      ? "SWAP.HIVE" 
      : ["General Pack", "Hueso Fusion", "LVL"].includes(pack) 
        ? "HUESO" 
        : "VIPHUESO";

      let cantidad = 0;
      switch (pack) {
        case "General Pack":
          cantidad = 3500 * input;
          break;
        case "Special Pack":
          cantidad = 50 * input;
          break;
        case "LVL":
          cantidad = 10000 * input;
            break;
        case "inicial":
          cantidad = 35 ;
            break;
        case "Hueso Fusion":
            cantidad = 1000 * input;
              break;
        default:
          cantidad = 3500 * input;
          break;
      }
      const json = {
        contractName: "tokens",
        contractAction: "transfer",
        contractPayload: {
          symbol: MONEDA,
          to: "mv-deposito",
          quantity: cantidad.toString(),
          memo: pack,
        },
      };

      const username = JSON.parse(sessionStorage.getItem("user"));
      window.hive_keychain.requestCustomJson(
        username.user,
        "ssc-mainnet-hive",
        "Active",
        JSON.stringify(json),
        "Transfer",
        function (response) {
          console.log(response)
        }
      );
    }
  };
  const handleClose = () => setOpen(false);
  const comprarSobre = (nombreSobre, descripcion) => {
    const hivepay = new HivePay("mv-deposito");
    hivepay
      .setItemName(nombreSobre)
      .setItemDescription(descripcion)
      .setNotifyUrl(`${URL}/api/notify/`)
      .setReturnUrl(`${URL}/game/`)
      .setAmount("10")
      .setCancel(`${URL}/game/`)
      .setBaseCurrency()
      .setPayCurrencies([ "SWAP.HIVE"]);
    hivepay.submit();
  };
  return (
    <Box
      sx={{
        backgroundImage: `url(https://res.cloudinary.com/druu0mcam/image/upload/v1719339319/Diseño_sin_título_56_htku49_qnv3i1.png)`,
        backgroundPosition: "bottom",
        backgroundSize: "cover",
        height: { xs: "100%", md: "91vh" },
        display: "flex",
        justifyContent: "center",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          m: 3,
          width: { xs: "120px", md: "130px" },
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CardMedia
          component="img"
          sx={{ width: "100%" }}
          image={'https://res.cloudinary.com/druu0mcam/image/upload/v1719350153/image_3_xnh2qd.png'}
          alt="tierra"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "white", fontSize: "1.3rem", textAlign: "center" }}
          >
            Initial Land
          </Typography>
          <Typography sx={{ color: "white" }}>35 - SWAP.HIVE <Typography sx={{color: "gold"}}>SPECIAL OFFER</Typography></Typography>
          {
            <Button
              disabled={informacion?.packInicial}
              onClick={() => handleOpen("inicial")}
              sx={{ width: "150px" }}
              variant="contained"
            >
              Buy
            </Button>
          }
        </Box>
      </Box>
      <Box
        sx={{
          m: 3,
          width: { xs: "120px", md: "130px" },
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CardMedia
          component="img"
          sx={{ width: "100%" }}
          image={
            "https://res.cloudinary.com/druu0mcam/image/upload/v1719350908/image_5_yyryo8.png"
          }
          alt="tierra"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "white", fontSize: "1.3rem", textAlign: "center" }}
          >
            LVL UP
          </Typography>
          <Typography sx={{ color: "white" }}> 10000 HUESO </Typography>
          {
            <Button     sx={{ width: "150px" }} onClick={() => handleOpen("LVL")} variant="contained">
              Buy
            </Button>
          }
        </Box>
      </Box>
      <Box
        sx={{
          m: 3,
          width: { xs: "120px", md: "130px" },
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CardMedia
          component="img"
          sx={{ width: "100%" }}
          image={
            "https://res.cloudinary.com/druu0mcam/image/upload/v1719339873/Sobres_de_figuritas_rip5gr_dd2fd7_1_kyxwq0_psvtit.png"
          }
          alt="tierra"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "white", fontSize: "1.3rem", textAlign: "center" }}
          >
            General Pack
          </Typography>
          <Typography sx={{ color: "white" }}> 3500 - HUESO </Typography>
          {
            <Button
              onClick={() => handleOpen("General Pack")}
              sx={{ width: "150px" }}
              variant="contained"
            >
              Buy
            </Button>
          }
        </Box>
      </Box>
      <Box
        sx={{
          m: 3,
          width: { xs: "120px", md: "160px" },
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CardMedia
          component="img"
          sx={{ width: "100%" }}
          image={
            "https://res.cloudinary.com/druu0mcam/image/upload/v1719339529/HUESOOROANIMADO_wpjjpv_y5y9ih.gif"
          }
          alt="tierra"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "white", fontSize: "1.3rem", textAlign: "center" }}
          >
            Hueso Fusion
          </Typography>
          <Typography sx={{ color: "white" }}> 1000 - HUESO </Typography>
          {
            <Button
              onClick={() => handleOpen("Hueso Fusion")}
              sx={{ width: "150px" }}
              variant="contained"
            >
              Buy
            </Button>
          }
        </Box>
      </Box>
      <Box
        sx={{
          m: 3,
          width: { xs: "120px", md: "130px" },
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CardMedia
          component="img"
          sx={{ width: "100%" }}
          image={
            "https://res.cloudinary.com/druu0mcam/image/upload/v1719339872/pack_special_cqkztw_1_ecp53e_qentqp.png"
          }
          alt="tierra"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ color: "white", fontSize: "1.3rem", textAlign: "center" }}
          >
            {" "}
            Special Pack
          </Typography>
          <Typography sx={{ color: "white" }}> 50 HUESO-VIP </Typography>
          {
            <Button
              onClick={() => handleOpen("Special Pack")}
              sx={{ width: "150px" }}
              variant="contained"
            >
              Buy
            </Button>
          }
        </Box>

      </Box>

      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              sx={{ textAlign: "center" }}
              id="modal-modal-title"
              color="white"
              variant="h6"
              component="h2"
            >
              Choose the amount to buy
            </Typography>
            <TextField
              onChange={(e) => setinput(e?.target.value)}
              value={input}
              sx={{ m: 1 }}
              fullWidth
              type="number"
            />
            <Button onClick={handlebuy} sx={{ m: 1 }} fullWidth variant="contained">
              {" "}
              Buy
            </Button>
          </Box>
        </Modal>
      </div>
    </Box>
  );
};
